import { REPORTSUMMARYTASKS_SUCCESS, REPORTSUMMARYTASKS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const reportSummaryTasksReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORTSUMMARYTASKS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case REPORTSUMMARYTASKS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default reportSummaryTasksReducer;
